/**
 * M13 — your week. A one-line recap on the first open of the week: briefs,
 * check-ins, things kept, people remembered. Only counts the payload
 * carries are spoken; the highlight names a check-in that happened. Row,
 * never dismissable. Out of the first cut on the server side — the
 * component exists so the registry is complete. The tap is `open` (insights).
 */

import { TrendingUp } from 'react-feather';
import { HomeGlyph, HomeRow } from '../HomeKit';
import { plural } from '../format';
import type { ModuleProps } from '../moduleTypes';

export function WeekModule({ module, onAction }: ModuleProps) {
  if (module.type !== 'week') return null;
  const { payload } = module;
  const parts: string[] = [];
  if (payload.briefs > 0) parts.push(plural(payload.briefs, 'brief'));
  if (payload.checkIns > 0) parts.push(plural(payload.checkIns, 'check-in'));
  if (payload.kept > 0) parts.push(`${plural(payload.kept, 'thing')} kept`);
  if (payload.remembered > 0) parts.push(`${plural(payload.remembered, 'person', 'people')} remembered`);
  const body = parts.length ? `Your week: ${parts.join(', ')}` : 'Your week: a quiet one';
  const sub = payload.highlight ? `and you checked in on ${payload.highlight.personName}` : undefined;

  return (
    <HomeRow
      reason={module.reason}
      body={body}
      sub={sub}
      glyph={
        <HomeGlyph tone="green">
          <TrendingUp size={13} />
        </HomeGlyph>
      }
      dismissable={false}
      onOpen={() => onAction?.({ kind: 'open' }, module)}
    />
  );
}
